module.exports = __webpack_public_path__ + "static/media/icon_close.e863f9e6.svg";